import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { PublicLayout } from "@/components/PublicLayout";

import Home from "@/pages/Home";
import Programs from "@/pages/Programs";
import Schedule from "@/pages/Schedule";
import Membership from "@/pages/Membership";
import Coaching from "@/pages/Coaching";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Vlog from "@/pages/Vlog";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import Bookings from "@/pages/dashboard/Bookings";
import Progress from "@/pages/dashboard/Progress";
import MembershipStatus from "@/pages/dashboard/MembershipStatus";
import AdminLayout from "@/pages/dashboard/admin/AdminLayout";
import AdminBlog from "@/pages/dashboard/admin/AdminBlog";
import AdminVlog from "@/pages/dashboard/admin/AdminVlog";
import AdminFounders from "@/pages/dashboard/admin/AdminFounders";
import AdminClasses from "@/pages/dashboard/admin/AdminClasses";
import AdminFoundingMembers from "@/pages/dashboard/admin/AdminFoundingMembers";
import AdminEnquiries from "@/pages/dashboard/admin/AdminEnquiries";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="grain-overlay" />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route index element={<Home />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/coaching" element={<Coaching />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/vlog" element={<Vlog />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Route>
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="bookings" element={<Bookings />} />
              <Route path="progress" element={<Progress />} />
              <Route path="membership" element={<MembershipStatus />} />
              <Route path="admin" element={<AdminLayout />}>
                <Route index element={<AdminEnquiries />} />
                <Route path="enquiries" element={<AdminEnquiries />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="vlog" element={<AdminVlog />} />
                <Route path="founders" element={<AdminFounders />} />
                <Route path="classes" element={<AdminClasses />} />
                <Route path="founding-members" element={<AdminFoundingMembers />} />
              </Route>
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
